/** Horizontal inset for focused-flow top bars and their aligned content column. */
export const FOCUSED_FLOW_HORIZONTAL_PADDING_PX = 24

/** Space above the focused-flow back/menu row — matches NavBarHeader py. */
export const FOCUSED_FLOW_HEADER_TOP_PADDING_PX = 24

/** Vertical gap between focused-flow rows on questionnaire question screens (header → bar, bar → content). */
export const FOCUSED_FLOW_PROGRESS_STACK_GAP_PX = 24

/** Internal padding around questionnaire question title text. */
export const QUESTION_TITLE_PADDING_PX = 8

/** Space below the title block before answer options on standard booking questionnaires. */
export const QUESTION_TITLE_BASELINE_GAP_PX = 16

/** Max width for focused-flow progress and completion content columns. */
export const FOCUSED_FLOW_CONTENT_MAX_WIDTH_PX = 460
